import { Outlet } from 'react-router-dom';
import SellerHeader from './SellerHeader';
import { useSellerStore } from '@stores';
import SellerFooter from './SellerFooter';
import { isDesktop } from 'react-device-detect';
import LocationPrompt from '@components/location/LocationPrompt';
import { useEffect } from 'react';

const SellerLayout = () => {
  const {
    isHome,
    setLocationData,
    inspectionConfig,
    showLocationPrompt,
    setShowLocationPrompt,
    hasLocationDenied,
    setHasLocationDenied
  } = useSellerStore();

  const handleLocationGranted = (locationData: any) => {
    setLocationData(locationData);
    setShowLocationPrompt(false);
  };

  const handleUpload = () => {
    setShowLocationPrompt(false);
  };

  const handleContinueWithoutLocation = () => {
    // Handle the case when user chooses to continue without location in WARNING_PROMPT mode
    setLocationData(null);
    setShowLocationPrompt(false);
  };

  const handleBack = () => {
    setShowLocationPrompt(false);
  };

  const handleLocationDenied = () => {
    // Remember that user has denied location for WARNING_PROMPT mode
    setHasLocationDenied(true);
    setLocationData(null);
    setShowLocationPrompt(false);
  };

  useEffect(() => {
    // Don't show location prompt if locationSharing is SILENT
    if (inspectionConfig?.locationSharing === 'SILENT' && showLocationPrompt) {
      setShowLocationPrompt(false);
    }

    // Don't show location prompt if user has already denied in WARNING_PROMPT mode
    if (
      inspectionConfig?.locationSharing === 'WARNING_PROMPT' &&
      hasLocationDenied &&
      showLocationPrompt
    ) {
      setShowLocationPrompt(false);
    }
  }, [
    inspectionConfig?.locationSharing,
    showLocationPrompt,
    setShowLocationPrompt,
    hasLocationDenied
  ]);

  // Don't render LocationPrompt if:
  // 1. locationSharing is SILENT
  // 2. locationSharing is WARNING_PROMPT and user has already denied
  const shouldShowLocationPrompt =
    showLocationPrompt &&
    inspectionConfig?.locationSharing !== 'SILENT' &&
    !(
      inspectionConfig?.locationSharing === 'WARNING_PROMPT' &&
      hasLocationDenied
    );

  return (
    <div
      className="w-full flex flex-col bg-grey-50"
      style={{ minHeight: 'calc(100vh - 82px)' }}>
      <div className={shouldShowLocationPrompt ? 'block' : 'hidden'}>
        <LocationPrompt
          onLocationGranted={handleLocationGranted}
          onUpload={handleUpload}
          locationSharing={inspectionConfig?.locationSharing}
          onContinueWithoutLocation={handleContinueWithoutLocation}
          onLocationDenied={handleLocationDenied}
          onBack={handleBack}
        />
      </div>
      <div className={shouldShowLocationPrompt ? 'hidden' : 'block'}>
        {(isHome || isDesktop) && <SellerHeader />}
        <div className="flex-auto flex flex-col bg-grey-50 relative no-scrollbar overflow-y-hidden">
          <Outlet />
        </div>
        {(isHome || isDesktop) && <SellerFooter />}
      </div>
    </div>
  );
};

export default SellerLayout;
